import { computed, ref, unref } from 'vue'
import { getContentByGrammarChecker } from '@/api/aiRelativeTools'
import { getNeedToKnowTemplateByIndustryType } from '@/utils/contentTemplate'
import { GrammarCheckerTemplate } from '@/enums/aiRelativeTools'
/**
 *
 * @param {*} props must wrapped with computed
 * @param {string} props.currencyCode
 * @param {string} props.template
 * @param {string} props.countryCode
 * @param {string} props.content
 * @param {string} props.industryType
 * @param {Function} props.handleGrammarChecker
 */
export function useGrammarChecker (props) {
  const localValue = ref('')
  const loading = ref(false)
  const isError = ref(false)
  const originalProps = computed(() => unref(props))

  const isNeedToKnowTemplate = computed(() => {
    return originalProps.value && originalProps.value.template === GrammarCheckerTemplate.BranchNeedToKnow
  })

  const isInvalid = computed(() => {
    if (!originalProps.value || !originalProps.value.template) {
      return true
    }

    return isNeedToKnowTemplate.value ? false : !originalProps.value.content
  })
  const currencyCode = computed(() => (originalProps.value.currencyCode === '$' ? null : originalProps.value.currencyCode))

  async function fetchGrammarChecker () {
    if (isInvalid.value) {
      return
    }

    try {
      loading.value = true
      localValue.value = ''
      isError.value = false
      if (isNeedToKnowTemplate.value) {
        const result = getNeedToKnowTemplateByIndustryType(originalProps.value.industryType, originalProps.value.countryCode)
        localValue.value = result
        return
      }

      const { data } = await getContentByGrammarChecker({
        content: originalProps.value.content,
        currencyCode: currencyCode.value,
        template: originalProps.value.template
      })

      localValue.value = data
    } catch (error) {
      console.error(error)
      isError.value = true
    } finally {
      loading.value = false
    }
  }

  function resetGrammarChecker () {
    loading.value = false
    localValue.value = ''
  }

  return {
    isInvalid,
    isError,
    value: localValue,
    loading,
    fetchGrammarChecker,
    resetGrammarChecker
  }
}
